import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  AlertTitle,
  Button,
  Divider,
  Grid,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import { styled } from "@mui/system";
import React, { useEffect, useMemo, useState } from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  createClaim,
  fetchAdminId,
  fetchClaimById,
  fetchClaimHistoryById,
  fetchpathology,
  getPreAuthTableData,
  submitClaim,
  updateClaim,
} from "../../action";
import { useQuery } from "../../Header";
import { useConvention } from "../../hooks/useConvention";
import CalendarPicker from "../../pickers/CalenderPicker";
import InsureeMedicalStatus from "../../pickers/InsureeMedicalStatus";
import InsureePicker from "../../pickers/InsureePicker";
import MedicalOfficerPicker from "../../pickers/MedicalOfficerPicker";
import VerificationPicker from "../../pickers/VerificationPicker";
import DialogBox from "../../reusableComponents/components/dialogs/DialogBox";
import CommonSnackbar from "../../reusableComponents/components/generics/CommonSnackbar";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import { CLAIM_PORTAL } from "../../utils/constant";
import { decodeId, formatNumber } from "../../utils/helper";
import {
  CLAIM_STATUS_APPROVED,
  CLAIM_STATUS_PAID,
  CLAIM_STATUS_PROCESSED,
  CLAIM_STATUS_REJECTED,
  CLAIM_STATUS_SUBMITTED,
} from "../../utils/statusMap";
import ClaimDocuments from "../ClaimDocuments";
import ClaimActsPannel from "./ClaimActsPannel";
import ClaimChat from "./ClaimChat";
import ClaimExaminationPannel from "./ClaimExaminationPannel";
import ClaimItemsPannel from "./ClaimItemsPannel";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "1rem",
}));

const StyledAlert = styled(Stack)(({ }) => ({
  marginLeft: "1.2rem",
}));

const StyledAlertTitle = styled(AlertTitle)(({ }) => ({
  fontWeight: "bold",
  color: "red",
}));

const ClaimForm = () => {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: claimId } = useParams();
  const [claimData, setClaimData] = useState();
  const [claimHistoryData, setClaimHistoryData] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [attachments, setAttachments] = useState();

  const [actsClaimData, setActsClaimData] = useState([]);
  const [serviceExaminationData, setServiceExaminationData] = useState([]);
  const [itemsServiceData, setItemsServiceData] = useState([]);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [InsureeCode, setInsureeCode] = useState(
    SignInSuccess?.profileReducer?.insureeByIdResponseData
  );

  const [payloadSubmit, setPayloadSubmit] = useState({});

  const [haveMedicalItem, setHaveMedicalItem] = useState(false);
  const [havePathology, setHavePathology] = useState(false);
  const [haveMedicalAct, setHaveMedicalAct] = useState(false);
  const [haveExamen, setHaveExamen] = useState(false);
  const [verificationWithoutBiometry, setVerificationWithoutBiometry] =
    useState(false);

  const [alertDialog, setAlertDialog] = useState(false);

  const [preAuthData, setPreAuthData] = useState({});

  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [hideMenu, setHideMenu] = useState(false);
  const query = useQuery();

  // const InsureeCode = SignInSuccess?.profileReducer?.insureeByIdResponseData
  const InsureecamuNumber =
    SignInSuccess?.profileReducer?.insureeByIdResponseData?.[0]?.camuNumber;
  const hf_Uuid =
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees?.[0]?.uuid;
  const priceListId = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees;
  const userId = SignInSuccess?.profileReducer?.currentUserResponseData?.id;
  const adminData = SignInSuccess?.fosaReducer?.AdminIdData;
  const HfInsuree = useSelector((state) => state?.fosaReducer?.HfInsuree);
  const insureeData = useSelector(
    (state) => state?.fosaReducer?.InsureeUuidData
  );
  const statusMapping = {
    1: t("Rejected"),
    2: t("Created"),
    4: t("Submitted"),
    8: t("Processed"),
    16: t("Approved"),
    32: t("Rework"),
    64: t("Paid"),
    128: t("Contentieux"),
  };
  const statusStyles = {
    1: { color: "red" },
    2: { color: "gray" },
    4: { color: "orange" },
    8: { color: "blue" },
    16: { color: "green" },
    32: { color: "red" },
    64: { color: "green" },
    128: { color: "orange" },
  };
  const isContentieux = claimData?.status == 1 && !claimData?.isFullRejected;
  const status = isContentieux ? 128 : claimData?.status;
  const statusText = statusMapping[status];
  const statusStyle = statusStyles[status];
  const VerificationCode = useSelector(
    (state) => state?.fosaReducer?.VerificationCode
  );
  const transFormMedicalInfo = (medicalInformationArray, selectedUuid) => {
    // Find the medical information object that matches the selected UUID
    const selectedMedicalInformation = medicalInformationArray.find(
      (info) => info.uuid === selectedUuid
    );

    // If a matching object is found, transform the data
    if (selectedMedicalInformation) {
      let transformData = {
        camuDoctor: {
          id: selectedMedicalInformation.id,
          uuid: selectedMedicalInformation.uuid,
          chfId: selectedMedicalInformation.chfId,
          lastName: selectedMedicalInformation.lastName,
          otherNames: selectedMedicalInformation.otherNames,
          camuNumber: selectedMedicalInformation.camuNumber,
          education: selectedMedicalInformation.education,
        },
      };
      return transformData;
    } else {
      // If no matching object is found, return null or handle the case as needed
      return null;
    }
  };
  const userData = useSelector((state) => state.profileReducer);
  const handleConfirmation = () => {
    setConfirmationDialog(true);
  };
  const handleClaimSubmit = async () => {
    dispatch(submitClaim(claimData.uuid));
    setConfirmationDialog(false);
    setSnackbarMessage(t("Claim Submitted SucessFully"));
  };

  useEffect(() => {
    setInsureeCode(SignInSuccess?.profileReducer?.insureeByIdResponseData);
  }, [SignInSuccess?.profileReducer?.insureeByIdResponseData]);

  useEffect(() => {
    if (query.get("hideMenuNavigation")) {
      setHideMenu(true);
    }
  }, [query]);

  useEffect(() => {
    const category =
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.category;
    if (category) {
      setHaveMedicalItem(category.haveMedicalItem);
      setHavePathology(category.havePathology);
      setHaveMedicalAct(category.haveMedicalAct);
      setHaveExamen(category.haveExamen);
      setVerificationWithoutBiometry(category.verificationWithoutBiometry);
    }
  }, [SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]?.category]);

  let mutation = SignInSuccess?.fosaReducer?.mutations;
  useEffect(() => {
    if (snackbarMessage) {
      if (mutation && mutation.length > 0 && mutation[0]?.status === 2) {
        setSnackbarSeverity("success");
        setConfirmationDialog(false);
        navigate(CLAIM_PORTAL);
        // setSnackbarMessage('Isuree Successfully add in to policyholder.');
        setSnackbarOpen(true);
      } else if (mutation && mutation.length > 0 && mutation[0]?.status === 1) {
        setSnackbarSeverity("error");
        setSnackbarMessage(t("Failed to done any action in Claims."));
        setSnackbarOpen(true);
        setConfirmationDialog(false);
      } else if (!mutation) {
        setSnackbarOpen(false);
        setConfirmationDialog(false);
      }
    }
  }, [mutation]);

  useEffect(() => {
    dispatch(fetchpathology());
  }, []);

  useEffect(() => {
    if (userId) {
      dispatch(fetchAdminId(userId));
    }
  }, [userId]);
  useEffect(() => {
    if (claimId) {
      dispatch(fetchClaimById(claimId));
      dispatch(fetchClaimHistoryById(claimId));
    }
  }, []);

  useEffect(() => {
    const { PreAuthData, getPreAuthData } = SignInSuccess?.fosaReducer;

    if (getPreAuthData?.length > 0) {
      setPreAuthData(getPreAuthData?.[0]);
    }

    if (PreAuthData?.length > 0) {
      setPreAuthData(PreAuthData?.[0]);
    }
  }, [SignInSuccess?.fosaReducer?.getPreAuthData, SignInSuccess?.fosaReducer?.PreAuthData]);

  useEffect(() => {
    if (claimId) {
      if (SignInSuccess?.fosaReducer?.ClaimByIdData) {
        setClaimData(SignInSuccess?.fosaReducer?.ClaimByIdData);
      }

      if (
        SignInSuccess?.fosaReducer?.ClaimByIdData?.insureeVerification
          ?.verificationCode
      ) {
        const verificationCode =
          SignInSuccess?.fosaReducer?.ClaimByIdData?.insureeVerification
            ?.verificationCode;
        dispatch(
          getPreAuthTableData([
            `insureeVerification_VerificationCode: "${verificationCode}"`,
          ])
        );
      }
    } else {
      setClaimData(null);
      setInsureeCode(null);
      setInsureeCode(null);
    }
  }, [SignInSuccess?.fosaReducer?.ClaimByIdData]);

  useEffect(() => {
    if (claimId) {
      if (SignInSuccess?.fosaReducer?.ClaimHistoryByIdData) {
        setClaimHistoryData(SignInSuccess?.fosaReducer?.ClaimHistoryByIdData);
      }
    } else {
      setClaimHistoryData(null);
    }
  }, [SignInSuccess?.fosaReducer?.ClaimHistoryByIdData]);

  let pathalogyList = SignInSuccess?.fosaReducer?.pathalogyList?.map(
    (diagnosis) => ({
      value: diagnosis.id,
      label: diagnosis.code.split(" ")[0],
    })
  );

  const pathalogyCodeList = SignInSuccess?.fosaReducer?.pathalogyList?.map(
    (diagnosis) => ({
      value: diagnosis.id,
      label: diagnosis.code.split(" ")[0],
    })
  );

  const handleSnackbarClose = async (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const visitType = [
    {
      value: "E",
      label: t("Emergency"),
    },
    {
      value: "O",
      label: t("Other"),
    },
    {
      value: "R",
      label: t("Referral"),
    },
  ];

  const claimType = [
    {
      value: "Act",
      label: "Acts",
    },
    {
      value: "exam",
      label: "Exam",
    },
    {
      value: "Products",
      label: "Products",
    },
  ];

  const consultationReason = [
    {
      value: "Maladie",
      label: "Maladie",
    },
    {
      value: "Maternite",
      label: "Maternite",
    },
    {
      value: "Leturedexamens",
      label: "Leture d'examens",
    },
    {
      value: "Actesaccordpréalable",
      label: "Actes accord préalable",
    },
    {
      value: "Référence",
      label: "Référence",
    },
    {
      value: "Urgence",
      label: "Urgence",
    },
  ];

  const handleClaimDataChange = (newData) => {
    const formatedData = newData.map((row) => ({
      actId: row.actId,
      priceAsked: row.price,
      qtyProvided: row.quantity,
      quantity: row.quantity,
      price: row.price,
      status: 1,
      jsonExt: JSON.stringify({
        countedPrice: row.countedPrice,
        tmValue: row.tmValue,
      }),
      extra: {
        quantity: row.quantity,
        price: row.price,
        tmValue: row.tmValue,
        countedPrice: row.countedPrice,
      },
    }));
    setActsClaimData(formatedData);
  };

  const handleExaminationData = (newData) => {
    const formatedData = newData.map((row) => ({
      actId: row.actId,
      priceAsked: row.price,
      qtyProvided: row.quantity,
      quantity: row.quantity,
      price: row.price,
      status: 1,
      jsonExt: JSON.stringify({
        countedPrice: row.countedPrice,
        tmValue: row.tmValue,
      }),
      extra: {
        quantity: row.quantity,
        price: row.price,
        tmValue: row.tmValue,
        countedPrice: row.countedPrice,
      },
    }));
    setServiceExaminationData(formatedData);
  };

  const handleItemsData = (newData) => {
    const formatedData = newData.map((row) => ({
      healthProductId: row.productId,
      itemId: row.productId, // kept for checkIfServiceDataIsEmpty
      priceAsked: row.price,
      qtyProvided: row.quantity,
      quantity: row.quantity,
      price: row.price,
      status: 1,
      explanation: row.explanation,
      jsonExt: JSON.stringify({
        countedPrice: row.countedPrice,
        tmValue: row.tmValue,
      }),
      extra: {
        quantity: row.quantity,
        price: row.price,
        tmValue: row.tmValue,
        countedPrice: row.countedPrice,
      },
    }));
    setItemsServiceData(formatedData);
  };

  const totalData = useMemo(() => {
    const items = [
      ...actsClaimData,
      ...serviceExaminationData,
      ...itemsServiceData,
    ];
    let total = 0;
    let totalTmValue = 0;
    let totalCounted = 0;

    for (let item of items) {
      if (item.extra) {
        total += item.extra.quantity * item.extra.price;
        totalTmValue += item.extra.quantity * item.extra.tmValue;
        totalCounted += item.extra.quantity * item.extra.countedPrice;
      }
    }

    return { total, totalTmValue, totalCounted };
  }, [actsClaimData, serviceExaminationData, itemsServiceData]);

  const validate = (values) => {
    const errors = {};

    if (!values.dateClaimed) {
      errors.dateClaimed = t("Field is required");
    }
    if (!values.insureeNo) {
      errors.insureeNo = t("Field is required");
    }
    if (!values.dateFrom) {
      errors.dateFrom = t("Field is required");
    }
    if (!values.visitType) {
      errors.visitType = t("Field is required");
    }
    if (havePathology && !values.icdId) {
      errors.icdId = t("Field is required");
    }
    if (!values.camuDoctor) {
      errors.camuDoctor = t("Field is required");
    }
    if (!values.insureeVerification) {
      errors.insureeVerification = t("Field is required");
    }
    return errors;
  };

  const onSubmit = async (values) => {
    const payload = {};
    const medicalInformation = values.camuDoctor;
    const medicalInfoPayload = transFormMedicalInfo(
      HfInsuree,
      medicalInformation
    );
    if (values.claimType) {
      medicalInfoPayload["ClaimType"] = values.claimType;
    }
    if (values.consultationReason) {
      medicalInfoPayload["ConsultantReason"] = values.consultationReason;
    }
    payload["code"] = claimData?.code;
    payload["uuid"] = claimData?.uuid;
    payload["insureeId"] = decodeId(
      SignInSuccess?.profileReducer?.insureeByIdResponseData?.[0]?.id
    );

    payload["insureeVerification"] = decodeId(
      typeof values.insureeVerification === "string"
        ? values.insureeVerification
        : values.insureeVerification.id
    );
    payload["adminId"] = adminData?.[0]?.claimAdmin?.id;
    payload["dateFrom"] = values.dateFrom;
    payload["dateTo"] = values.dateTo;
    payload["icdId"] = values.icdId;
    payload["icd1Id"] = values.icd1Id;
    payload["icd2Id"] = values.icd2Id;
    payload["icd3Id"] = values.icd3Id;
    payload["icd4Id"] = values.icd4Id;
    payload["jsonExt"] = medicalInfoPayload;
    payload["feedbackStatus"] = 1;
    payload["reviewStatus"] = 1;
    payload["dateClaimed"] = values.dateClaimed;
    payload["healthFacilityId"] =
      userData?.currentUserResponseData?.i_user?.health_facility_id;
    payload["visitType"] = values.visitType;
    payload["services"] = [];
    payload["acts"] = [...actsClaimData, ...serviceExaminationData];
    payload["claimProducts"] = [...itemsServiceData];
    payload["attachments"] = attachments;

    const checkIfServiceDataIsEmpty = (data) => {
      if (data?.length === 0) {
        return false;
      }

      if (data?.[0]?.serviceId || data?.[0]?.itemId) {
        return true;
      }

      return false;
    };

    const checkIfActsDataIsEmpty = (data) => {
      if (data?.length === 0) {
        return false;
      }
      return !!data?.[0]?.actId;
    };

    const medicalActLength = checkIfActsDataIsEmpty(actsClaimData);
    const examenLength = checkIfActsDataIsEmpty(serviceExaminationData);
    const medicalItemLength = checkIfServiceDataIsEmpty(itemsServiceData);

    if (!medicalActLength && !examenLength && !medicalItemLength) {
      setSnackbarOpen(true);
      setSnackbarSeverity("error");
      setSnackbarMessage(
        "Vous devez ajouter au moins un acte, un examen ou un produit"
      );
      return;
    }

    setPayloadSubmit(payload);
    setConfirmationDialog(true);
  };

  const confirmSubmit = async (payload) => {
    if (claimData?.uuid) {
      setSnackbarOpen(true);
      await dispatch(updateClaim(payload));
      setSnackbarSeverity("success");
      setSnackbarMessage(t("Claim Update Sucessfully"));
      setTimeout(() => {
        closeDialogBox();
      }, 1000);
    } else {
      setSnackbarOpen(true);
      await dispatch(createClaim(payload));
      setSnackbarSeverity("success");
      setSnackbarMessage(t("Claim Create Sucessfully"));
      setTimeout(() => {
        closeDialogBox();
      }, 1000);
    }
  };

  const goBack = () => {
    navigate(-1);
  };

  const jsonExtData = claimData?.jsonExt ? JSON.parse(claimData.jsonExt) : {};

  const initialValues = {
    dateClaimed: claimData?.dateClaimed ? claimData?.dateClaimed : "",
    claimNo: claimData?.code ? claimData?.code : "",
    insureeNo: claimData?.insuree?.camuNumber
      ? claimData?.insuree?.camuNumber
      : "",
    insureeVerification: !!claimData?.insureeVerification?.id
      ? claimData?.insureeVerification?.id
      : "",
    visitType: claimData?.visitType ? claimData?.visitType : "",
    icdId: claimData?.icd ? claimData?.icd?.id : "",
    icd1Id: claimData?.icd1 ? claimData?.icd1?.id : "",
    icd2Id: claimData?.icd2 ? claimData?.icd2?.id : "",
    icd3Id: claimData?.icd3 ? claimData?.icd3?.id : "",
    icd4Id: claimData?.icd4 ? claimData?.icd4?.id : "",
    dateFrom: claimData?.dateFrom ? claimData?.dateFrom : "",
    dateTo: claimData?.dateTo ? claimData?.dateTo : "",
    declarationValidTo: claimData?.contract?.dateValidTo
      ? claimData?.contract?.dateValidTo
      : "",
    expectedAmount: claimData?.expectedAmount ? claimData?.expectedAmount : "",
    parentPendingPayment: claimData?.parentPendingPayment
      ? claimData?.parentPendingPayment
      : "",
    contractPenaltyAmount: claimData?.contractPenaltyAmount
      ? claimData?.contractPenaltyAmount
      : "",
    parentPaymentPenalty: claimData?.parentPaymentPenalty
      ? claimData?.parentPaymentPenalty
      : "",
    typeOfPayment: claimData?.typeOfPayment ? claimData?.typeOfPayment : "",
    receivedAmountOne: claimData?.receivedAmountOne
      ? claimData?.receivedAmountOne
      : "",
    receiptNo: claimData?.receiptNo ? claimData?.receiptNo : "",
    receivedAmountTwo: claimData?.receivedAmountTwo
      ? claimData?.receivedAmountTwo
      : "",
    receiptNoTwo: claimData?.receiptNoTwo ? claimData?.receiptNoTwo : "",
    receivedAmountThree: claimData?.receivedAmountThree
      ? claimData?.receivedAmountThree
      : "",
    receiptNoThree: claimData?.receiptNoThree ? claimData?.receiptNoThree : "",
    camuDoctor: jsonExtData?.camuDoctor?.uuid || "",
    consultationReason: jsonExtData?.ConsultantReason || "",
    claimType: jsonExtData?.ClaimType || "",
  };


  useEffect(() => {
    const { PreAuthData, getPreAuthData, pickerHealthFacilityInsurees } = SignInSuccess?.fosaReducer;

    const pre_auth_data = getPreAuthData?.length > 0 ? getPreAuthData?.[0] : null;

    if (pre_auth_data) {
      if (
        pickerHealthFacilityInsurees &&
        pre_auth_data?.healthFacility?.fosaCode !=
        pickerHealthFacilityInsurees?.[0]?.fosaCode
      ) {
        setAlertDialog(true);
      } else {
        setClaimData(pre_auth_data);
      }
    }
  }, [
    SignInSuccess?.fosaReducer?.getPreAuthData,
    dispatch,
    // SignInSuccess?.fosaReducer?.PreAuthData,
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees
  ]);

  const closeDialogBox = () => {
    navigate(CLAIM_PORTAL);
  };

  const closeMsgDialoge = () => {
    setIsPopupOpen(false);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const { isConventionnementActive } = useConvention();

  // When claimData has data from getPreauthData (paActs, paProducts), pass normalized data to panels
  const claimDataForActs = useMemo(() => {
    if (!claimData) return claimData;
    const acts = claimData.paActs?.length > 0 ? claimData.paActs : claimData.acts;
    return { ...claimData, acts: acts ?? [] };
  }, [claimData]);

  const claimDataForExamination = useMemo(() => {
    if (!claimData) return claimData;
    const acts = claimData.paActs?.length > 0 ? claimData.paActs : claimData.acts;
    const examinationActs = (acts ?? []).filter(
      (a) => (a?.act?.actType?.label || "").toLowerCase() === "examination"
    );
    return { ...claimData, acts: examinationActs };
  }, [claimData]);

  const claimDataForItems = useMemo(() => {
    if (!claimData) return claimData;
    const claimProducts =
      claimData.paProducts?.length > 0
        ? claimData.paProducts
        : claimData.claimProducts ?? claimData.items;
    return { ...claimData, claimProducts: claimProducts ?? [], items: claimData.paProducts?.length > 0 ? [] : (claimData.items ?? []) };
  }, [claimData]);

  // IDs of acts/products that come from paActs/paProducts — those rows cannot be removed (item-by-item)
  const nonRemovableActIds = useMemo(() => {
    const pa = preAuthData?.paActs ?? [];
    return new Set(
      pa
        .map((a) => a?.act?.uuid ?? a?.act?.id)
        .filter((id) => id != null && id !== "")
        .map((id) => String(id))
    );
  }, [preAuthData?.paActs]);

  const nonRemovableExaminationActIds = useMemo(() => {
    const pa = preAuthData?.paActs ?? [];
    return new Set(
      pa
        .filter(
          (a) => (a?.act?.actType?.label || "").toLowerCase() === "examination"
        )
        .map((a) => a?.act?.uuid ?? a?.act?.id)
        .filter((id) => id != null && id !== "")
        .map((id) => String(id))
    );
  }, [preAuthData?.paActs]);

  const nonRemovableProductIds = useMemo(() => {
    const pp = preAuthData?.paProducts ?? [];
    return new Set(
      pp
        .map((p) => p?.healthProduct?.uuid ?? p?.healthProduct?.id)
        .filter((id) => id != null && id !== "")
        .map((id) => String(id))
    );
  }, [preAuthData?.paProducts]);

  const handlePopup = (message) => {
    console.log(message, "isPopupOpen");

    setPopupMessage(message);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setPopupMessage("");
  };

  const isNotEditable = isContentieux
    ? false
    : [
      //CLAIM_STATUS_REJECTED,

      CLAIM_STATUS_SUBMITTED,
      CLAIM_STATUS_PROCESSED,
      CLAIM_STATUS_APPROVED,
      CLAIM_STATUS_PAID,
    ].includes(claimData?.status) || !isConventionnementActive;

  const isRejected = CLAIM_STATUS_REJECTED === claimData?.status;

  return (
    <Grid>
      {!hideMenu && (
        <Grid>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={goBack}
            style={{ color: "black" }}
          >
            {t("BacktoClaimList")}
          </Button>
          <Grid>
            <Typography variant="h6">
              {claimData?.uuid ? t("Updateaclaim") : t("SubmitANewClaim")}
            </Typography>
          </Grid>
        </Grid>
      )}

      {(claimData?.status == 1 ||
        (claimData?.reworkReason && claimData?.status == 32)) && (
          <Grid container style={{ maxWidth: "fit-content" }}>
            <StyledAlert>
              <Alert
                severity="error"
                sx={{
                  border: "1px solid red",
                  backgroundColor: "#ffe6e6", // light red background
                  color: "red",
                }}
              >
                <StyledAlertTitle>
                  {claimData?.status == 1 && claimData?.isFullRejected
                    ? t(
                      "Claim is rejected with the following reason. Kindly provide required information and re-submit the claim."
                    )
                    : claimData?.reworkReason && claimData?.status == 32
                      ? t(
                        "Claim is reverted with the following reason. Kindly provide required information and re-submit the claim."
                      )
                      : ""}

                  {claimData?.status == 1 && !claimData?.isFullRejected && (
                    <Typography>
                      {t(
                        "La feuille de soin est en contentieux pour les raisons suivantes :"
                      )}
                    </Typography>
                  )}
                </StyledAlertTitle>
                {/* {!claimData?.rejectionReason == 20 && <Typography>
                                Reason: {"hello"}
                            </Typography>} */}
                {claimData?.status == 1 && (
                  <Typography>
                    {t("Comment")}:{" "}
                    {claimData?.rejectionComment &&
                      t(claimData?.rejectionComment)}
                  </Typography>
                )}
                {claimData?.reworkReason && claimData?.status == 32 && (
                  <Typography>
                    {t("Comment")}:{" "}
                    {claimData?.reworkReason && claimData?.reworkReason}
                  </Typography>
                )}
              </Alert>
            </StyledAlert>
          </Grid>
        )}

      <Form
        onSubmit={onSubmit}
        validate={validate}
        initialValues={initialValues}
        render={({
          handleSubmit,
          form,
          submitting,
          pristine,
          values,
          errors,
        }) => (
          <form onSubmit={handleSubmit}>
            <StyledPaper>
              <Grid>
                <StyledPaperHeader>
                  <Grid
                    item
                    alignItems="center"
                    display={"flex"}
                    justifyContent={"space-between"}
                  >
                    <Typography variant="h6" sx={{ flex: 1 }}>
                      {t("ClaimDetails")}
                    </Typography>
                    {preAuthData?.id && claimData?.uuid && (
                      <Typography
                        variant="h6"
                        sx={{ cursor: "pointer", mx: 2 }}
                        onClick={() => {
                          setShowIframe(true);
                          setIframeUrl(
                            `/fosa/preautharizationForm/:id=${preAuthData?.id}?hideMenuNavigation=yes`
                          );
                        }}
                      >
                        <span
                          style={{ color: "orange" }}
                        >{`Accord préalable attaché`}</span>
                      </Typography>
                    )}
                    {statusText && (
                      <Typography variant="h6">
                        {t("Status")}:{" "}
                        <span style={statusStyle}>{statusText}</span>
                      </Typography>
                    )}
                  </Grid>
                </StyledPaperHeader>

                <Grid container style={{ padding: "1rem" }}>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="dateClaimed"
                      component={CalendarPicker}
                      required
                      label={"DateClaimed"}
                      onChange={(value) => form.change("dateClaimed", value)}
                      inputVal={values?.dateClaimed}
                      disabled={claimData?.uuid}
                    />
                  </Grid>
                  <Grid item xs={6} className="common-input">
                    <Field
                      name="insureeNo"
                      component={InsureePicker}
                      label={t("TemporaryCAMU")}
                      required
                      type="text"
                      insureeNo={values}
                      requiredCamuNumber
                      disabled={claimData?.uuid}
                    />
                  </Grid>

                  {!claimData?.uuid && (
                    <Grid
                      item
                      xs={3}
                      className="common-input"
                      style={{ marginTop: "2px" }}
                    >
                      <Field
                        name="insureeVerification"
                        component={VerificationPicker}
                        label={t("VerificationCode")}
                        hfUuid={InsureecamuNumber}
                        insureeVerification={values.insureeVerification}
                        disabled={isNotEditable}
                        verificationWithoutBiometry={
                          verificationWithoutBiometry
                        }
                      />
                    </Grid>
                  )}

                  {claimData?.uuid && (
                    <Grid
                      item
                      xs={3}
                      className="common-input"
                      style={{ marginTop: "2px" }}
                    >
                      <TextInput
                        name="insureeVerification"
                        value={
                          claimData?.insureeVerification?.verificationCode
                            ? claimData?.insureeVerification?.verificationCode
                            : ""
                        }
                        label={t("verifivationTextbox")}
                        type="text"
                        disabled={true}
                      />
                    </Grid>
                  )}

                  <Grid item xs={3} className="common-input">
                    <Field
                      name="dateFrom"
                      component={CalendarPicker}
                      label={"DateFrom"}
                      type="text"
                      onChange={(value) => form.change("dateFrom", value)}
                      inputVal={values?.dateFrom}
                      disabled={isNotEditable}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="dateTo"
                      component={CalendarPicker}
                      label={"Dateto"}
                      type="text"
                      onChange={(value) => form.change("dateTo", value)}
                      inputVal={values?.dateTo}
                      disabled={isNotEditable}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="claimNo"
                      component={TextInput}
                      label={t("Claim No.")}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="visitType"
                      component={Dropdown}
                      label={t("VisitType")}
                      options={visitType}
                      disabled={isNotEditable}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="consultationReason"
                      component={Dropdown}
                      label={t("ConsultationReason")}
                      options={consultationReason}
                      disabled={isNotEditable}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="claimType"
                      component={Dropdown}
                      label={t("ClaimType")}
                      options={claimType}
                      disabled={isNotEditable}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="gurantteeNo   "
                      component={TextInput}
                      label={"GuaranteeNo."}
                      type="text"
                      disabled={isNotEditable}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input"></Grid>

                  {havePathology && (
                    <>
                      <Grid item xs={12} style={{ margin: "1rem 0 1.5rem" }}>
                        <Divider />
                      </Grid>

                      <Grid item xs={3} className="common-input">
                        <Field
                          name="icdId"
                          component={Dropdown}
                          label={t("Pathalogy1*")}
                          options={pathalogyList}
                          disabled={isNotEditable}
                        />
                      </Grid>

                      <Grid item xs={3} className="common-input">
                        <Field
                          name="icd2Id"
                          component={Dropdown}
                          label={t("Pathalogy2")}
                          options={pathalogyList}
                          disabled={isNotEditable}
                        />
                      </Grid>

                      <Grid item xs={3} className="common-input">
                        <Field
                          name="icd3Id"
                          component={Dropdown}
                          label={t("Pathalogy3")}
                          options={pathalogyList}
                          disabled={isNotEditable}
                        />
                      </Grid>

                      <Grid item xs={3} className="common-input">
                        <Field
                          name="icd4Id"
                          component={Dropdown}
                          label={t("Pathalogy4")}
                          options={pathalogyList}
                          disabled={isNotEditable}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </StyledPaper>

            <StyledPaper>
              <Grid>
                <StyledPaperHeader>
                  <Grid item alignItems="center">
                    <Typography variant="h6">
                      {t("InsureeInformation")}
                    </Typography>
                  </Grid>
                </StyledPaperHeader>

                <Grid container style={{ padding: "1rem" }}>
                  <Grid item xs={3} className="common-input">
                    <TextInput
                      name="camuCode"
                      label={"CAMUCode"}
                      value={
                        InsureeCode?.[0]?.policyholderinsureeSet
                          ? InsureeCode?.[0]?.policyholderinsureeSet?.edges?.[0]
                            ?.node?.policyHolder?.code
                          : ""
                      }
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <TextInput
                      name="tradeName"
                      value={
                        InsureeCode?.[0]?.policyholderinsureeSet
                          ? InsureeCode?.[0]?.policyholderinsureeSet?.edges?.[0]
                            ?.node?.policyHolder?.tradeName
                          : ""
                      }
                      label={"Trade Name"}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    className="common-input"
                    style={{ marginTop: "2px" }}
                  >
                    <TextInput
                      name="camuNumber"
                      value={
                        InsureeCode?.[0]?.chfId ? InsureeCode?.[0]?.chfId : ""
                      }
                      label={"CAMUNo."}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <TextInput
                      name="givenName"
                      value={
                        InsureeCode?.[0]?.otherNames
                          ? InsureeCode?.[0]?.otherNames
                          : ""
                      }
                      label={"GivenName"}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <TextInput
                      name="insureeName"
                      value={
                        InsureeCode?.[0]?.otherNames
                          ? InsureeCode?.[0]?.otherNames
                          : ""
                      }
                      label={t("Insuree Name")}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <TextInput
                      name="insureeCamuNumber"
                      value={
                        InsureeCode?.[0]?.camuNumber
                          ? InsureeCode?.[0]?.camuNumber
                          : ""
                      }
                      label={"InsureeCamuNo"}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <TextInput
                      name="insureeAge"
                      value={InsureeCode?.[0]?.age ? InsureeCode?.[0]?.age : ""}
                      label={"Age"}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <TextInput
                      name="insureeGender"
                      value={
                        InsureeCode?.[0]?.gender?.gender
                          ? InsureeCode?.[0]?.gender?.gender
                          : ""
                      }
                      label={"Gender"}
                      type="text"
                      disabled={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </StyledPaper>

            <Grid>
              <StyledPaper>
                <Grid>
                  <StyledPaperHeader>
                    <Grid item alignItems="center">
                      <Typography variant="h6">
                        {t("MedicalInformation")}
                      </Typography>
                    </Grid>
                  </StyledPaperHeader>

                  <Grid container style={{ padding: "1rem" }}>
                    <Grid item xs={3} className="common-input">
                      <Field
                        name="camuDoctor"
                        component={MedicalOfficerPicker}
                        label={t("DoctorCamuNo.*")}
                        hf_Uuid={hf_Uuid}
                        value={"test"}
                        disabled={isNotEditable}
                      />
                    </Grid>
                    {values?.camuDoctor && (
                      <Grid item xs={3} className="common-input">
                        <TextInput
                          name="lastName"
                          value={
                            insureeData?.[0]?.lastName
                              ? insureeData?.[0]?.lastName
                              : ""
                          }
                          label={t("Last Name")}
                          required
                          type="text"
                          disabled={true}
                        />
                      </Grid>
                    )}
                    {values?.camuDoctor && (
                      <Grid item xs={3} className="common-input">
                        <TextInput
                          name="firstName"
                          value={
                            insureeData?.[0]?.otherNames
                              ? insureeData?.[0]?.otherNames
                              : ""
                          }
                          label={t("First Name")}
                          type="text"
                          disabled={true}
                        />
                      </Grid>
                    )}
                    {values?.camuDoctor && (
                      <Grid item xs={3} className="common-input">
                        <TextInput
                          name="education"
                          value={
                            insureeData?.[0]?.education
                              ? insureeData?.[0]?.education
                              : ""
                          }
                          label={t("Education")}
                          type="text"
                          disabled={true}
                        />
                      </Grid>
                    )}
                    {values?.camuDoctor && (
                      <Grid item xs={3} className="common-input">
                        <InsureeMedicalStatus
                          name="fosaStatus"
                          label={t("fosaStatus")}
                          type="text"
                          disabled={true}
                          hf_Uuid={hf_Uuid}
                          values={values.camuDoctor}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </StyledPaper>
            </Grid>

            {haveMedicalAct && (
              <Grid container>
                <Grid item xs={12}>
                  <ClaimActsPannel
                    priceListId={priceListId}
                    InsureeCode={InsureeCode}
                    onDataChange={handleClaimDataChange}
                    claimData={claimDataForActs}
                    onPopup={handlePopup}
                    disabled={isNotEditable}
                    nonRemovableActIds={nonRemovableActIds}
                    preAuthData={preAuthData}
                  />
                </Grid>
              </Grid>
            )}

            {haveExamen && (
              <Grid container>
                <Grid item xs={12}>
                  <ClaimExaminationPannel
                    onDataChange={handleExaminationData}
                    claimData={claimDataForExamination}
                    disabled={isNotEditable}
                    nonRemovableExaminationActIds={nonRemovableExaminationActIds}
                    preAuthData={preAuthData}
                  />
                </Grid>
              </Grid>
            )}

            {haveMedicalItem && (
              <Grid container>
                <Grid item xs={12}>
                  <ClaimItemsPannel
                    onDataChange={handleItemsData}
                    claimData={claimDataForItems}
                    disabled={isNotEditable}
                    nonRemovableProductIds={nonRemovableProductIds}
                    preAuthData={preAuthData}
                  />
                </Grid>
              </Grid>
            )}

            <Grid>
              <ClaimDocuments
                setAttachments={setAttachments}
                claimData={claimData}
                disabled={isNotEditable}
              />
            </Grid>

            {claimData?.uuid && (
              <Grid>
                <ClaimChat
                  claimUuid={claimData.uuid}
                  disabled={isNotEditable}
                />
              </Grid>
            )}

            <StyledPaper>
              <Grid container spacing={2} style={{ padding: "1rem" }}>
                <Grid item xs={8}></Grid>
                <Grid item xs={4}>
                  <Grid container direction="column" spacing={3}>
                    <Grid item xs={12}>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell>
                              <Typography>{t("Total")}</Typography>
                            </TableCell>
                            <TableCell align="right">
                              <strong>{formatNumber(totalData.total)}</strong>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography>
                                {t("TotalSupportedbyInsuree")}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <strong>
                                {formatNumber(totalData.totalTmValue)}
                              </strong>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>
                              <Typography>
                                {t("TotalSupportedbyCamu")}
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              <strong>
                                {formatNumber(totalData.totalCounted)}
                              </strong>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
                    {!isNotEditable && !isRejected && (
                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={
                            submitting ||
                            pristine ||
                            Object.keys(errors).length > 0
                          }
                        >
                          {t("SaveasDraft")}
                        </Button>
                      </Grid>
                    )}
                    {isContentieux && (
                      <Grid item xs={12}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={
                            submitting || Object.keys(errors).length > 0
                          }
                        >
                          {t("Enregistrer")}
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </StyledPaper>
          </form>
        )}
      />

      <Dialog
        fullWidth={true}
        maxWidth={"xl"}
        open={showIframe}
        onClose={() => {
          setShowIframe(false);
        }}
      >
        <DialogTitle style={{ fontWeight: 600 }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {`Accord préalable attaché`}
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => {
                setShowIframe(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <iframe
            src={iframeUrl}
            width="100%"
            height="800"
            style={{ width: "100%", height: "800px", border: "none" }}
            title="Pre-Authorization Form"
          ></iframe>
        </DialogContent>
      </Dialog>

      {confirmationDialog && (
        <DialogBox
          open={confirmationDialog}
          onClose={() => {
            setPayloadSubmit({});
            setConfirmationDialog(false);
          }}
          onAgree={() => {
            confirmSubmit(payloadSubmit);
            setConfirmationDialog(false);
            // closeDialogBox();
          }}
          title="Confirmation"
          content={t("Are you sure you want to Submit the Claim?")}
          agreeLabel={t("Submit")}
          disagreeLabel={t("cancel")}
        />
      )}
      {alertDialog && (
        <DialogBox
          open={alertDialog}
          onClose={() => setAlertDialog(false)}
          onAgree={closeDialogBox}
          title="Alert"
          content={t("Health Facilities are not same")}
          agreeLabel={t("Ok")}
          disagreeLabel={t("cancel")}
        />
      )}

      <CommonSnackbar
        open={snackbarOpen}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Grid>
  );
};

export default ClaimForm;
